<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
</style>

<script>
  import ButtonWithTooltip from "@sourcewhale/shared/svelte-design-system/components/atoms/ButtonWithTooltip.svelte";
  import FeedbackDropdown from "./FeedbackDropdown.svelte";

  import { companyInsightsStore } from "../stores";

  let disabled = true;

  let el;
  let show;
  let close = () => {};

  const onclick = () => {
    if (show)
      close(); // resets other props in FeedbackDropdown
    else show = true;
  };

  // Reset when the companyInsightsStore changes
  companyInsightsStore.subscribe(($store) => {
    show = false;
    disabled = !($store && Object.keys($store).length > 0);
  });
</script>

<ButtonWithTooltip
  bind:el
  kind="tertiary-grey"
  size="small"
  leadingIcon="far fa-message-smile"
  {onclick}
  {disabled}
  class={disabled ? "disabled" : ""}
  style="outline-offset: -2px;"
  placement="left"
>
  <span slot="tooltip"> Report an issue </span>
</ButtonWithTooltip>

<FeedbackDropdown bind:el bind:show bind:close />
